


















import { defineComponent } from "@vue/composition-api";
import { ContentFeed } from "@scrile/api-provider/dist/projects/scrileConnect/ContentFeedProvider";
import useAuthUser from "@/hooks/useAuthUser";
import { getElement } from "@/lib/elementHelpers";
import ContentFeedCover from "@/components/ContentFeedCover";
import InfiniteScroll from "@/components/InfiniteScroll";

export default defineComponent({
  name: "ContentFeedGrid",
  components: { InfiniteScroll, ContentFeedCover },
  props: {
    contentFeedList: { type: Array as () => ContentFeed[], required: true },
    feedId: { type: String },
    enableScroll: { type: Boolean, default: true },
    enablePinPost: { type: Boolean, default: true },
  },
  setup() {
    const { authUser, authorities } = useAuthUser();
    return {
      authUser,
      authorities,
    };
  },
  computed: {
    authUserId(): string {
      return this.authUser?.id ?? "";
    },
  },
  watch: {
    feedId(feedIdNew?: string, feedIdOld?: string) {
      setTimeout(() => {
        if (feedIdOld && !feedIdNew) {
          const selectedIndex = this.contentFeedList.findIndex(i => i.id === feedIdOld);
          getElement<HTMLElement>(this.$refs.feeds, selectedIndex).scrollIntoView({
            block: "center",
            behavior: "auto",
          });
        }
      }, 0);
    },
  },
});
